import { defineStore } from 'pinia';
import { getRiaPlansByEntityV2 } from '@api/ria';
import { ref } from 'vue';
import { RiaPlan } from 'types/plan';

export const usePlansStore = defineStore('plans', () => {
	const selectedPlan = ref<RiaPlan | null>(null);
	const availableRiaPlans = ref<Array<RiaPlan>>([]);
	const availableFunds = ref<Array<RiaPlan>>([]);
	const isFmpCardFlow = ref(false);

	async function getAvailableRiaPlans(): Promise<void> {
		if (availableRiaPlans.value.length === 0 && availableFunds.value.length === 0) {
			const { riaPlans, funds } = await getRiaPlansByEntityV2();
			availableRiaPlans.value = riaPlans;
			availableFunds.value = funds;
		}
	}

	function $reset(): void {
		selectedPlan.value = null;
		availableRiaPlans.value = [];
		availableFunds.value = [];
		isFmpCardFlow.value = false;
	}

	return {
		selectedPlan,
		availableRiaPlans,
		availableFunds,
		isFmpCardFlow,
		getAvailableRiaPlans,
		$reset
	};
});
